import actions from '../../actions/DisabilityBenefitsSets'
import { connectPlanSharedBusinessRules } from '../PlanSharedBusinessRules/CreateBusinessRulesShow'

export default connectPlanSharedBusinessRules('Disability', actions.show.main, actions.show.reset)
